import { useEffect, useState } from "react";
import { FileDown, Radio } from "lucide-react";

const PDF_URL = `${process.env.REACT_APP_BACKEND_URL}/api/capability-statement.pdf`;

export default function MobileCta() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 480);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`lg:hidden fixed bottom-0 left-0 right-0 z-40 border-t border-slate-800 bg-[#0D0F12]/95 backdrop-blur-xl transition-transform duration-300 ${
        show ? "translate-y-0" : "translate-y-full"
      }`}
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="mobile-cta-bar"
    >
      <div className="grid grid-cols-2 divide-x divide-slate-800">
        <a
          href={PDF_URL}
          download
          className="flex items-center justify-center gap-2 min-h-[52px] font-mono text-[11px] tracking-[0.15em] uppercase text-slate-200 active:bg-slate-900"
          data-testid="mobile-cta-pdf-link"
        >
          <FileDown className="w-4 h-4 text-amber-600" /> Capability PDF
        </a>
        <a
          href="#contact"
          className="flex items-center justify-center gap-2 min-h-[52px] font-mono text-[11px] tracking-[0.15em] uppercase bg-[#4A5D4E] text-white active:bg-[#55695A]"
          data-testid="mobile-cta-contact-link"
        >
          <Radio className="w-4 h-4" /> Contact Desk
        </a>
      </div>
    </div>
  );
}
